module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-mobile-es.3ab51f62.webp";